export const setErrorFormSimpleUtil = (errors, touched, key, customError) => {
    return customError ?? (errors[key] && touched[key] ? errors[key] : undefined);
};
